import { device } from '@/styles/common';
import styled from 'styled-components';

export const TopFoldHeaderContainer = styled.div`
  background: #212738;
  width: 100%;
  height: 52px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;

  @media ${device.mobileS} {
    padding: 0 16px;
  }
`;

export const LeftFold = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;

export const FoldOptionLeft = styled.div<{
  onClick?: () => void;
  selected: boolean;
  disabled?: boolean;
}>`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.selected ? '#FFFFFF' : '#A3A9C2')};

  // if onClick is defined, then it is clickable, and we define the hover state
  ${(props) => props.onClick && !props.disabled && '&:hover { cursor: pointer; color: #ffffff; }'}
  transition: color 0.2s ease-in-out;
`;

export const RightFold = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  @media ${device.mobileS} {
    gap: 12px;
  }
`;

export const FoldOptionRight = styled(FoldOptionLeft)`
  text-align: right;
`;
